<template>
  <div class="user-profile">
    <div class="card">
      <div class="card-header">
        <h3>Editar meus dados</h3>
      </div>
      <div class="card-body">
        <form
          ref="editUserForm"
          class="text-center"
          @submit.prevent="onSubmit"
          @keydown.enter.prevent="onSubmit">
          <ErrorAlert :error="error" :centered="true" />
          <div class="form-group row">
            <label
              for="email"
              class="col-sm-4 col-form-label">Email</label>
            <div class="col-sm-8">
              <input
                id="email"
                type="text"
                class="form-control user-email"
                v-model="email"
                disabled>
            </div>
          </div>
          <div class="form-group row">
            <label
              for="name"
              class="col-sm-4 col-form-label">Nome</label>
            <div class="col-sm-8">
              <input
                id="name"
                type="text"
                class="form-control user-name"
                v-model="name"
                required>
            </div>
          </div>
          <div class="form-group row">
            <label
              for="phone"
              class="col-sm-4 col-form-label">Telefone</label>
            <div class="col-sm-8">
              <input
                id="phone"
                type="text"
                class="form-control user-phone"
                placeholder="(00) 00000-0000"
                maxlength="15"
                v-model="phoneDisplay"
                @keydown="allowOnlyNumericKeydown">
            </div>
          </div>
          <div class="buttons flex">
            <button
              type="submit"
              class="btn btn-primary user-save"
              @click.prevent="onSubmit">
              Atualizar
            </button>
          </div>
        </form>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="editUserSuccess"
      ref="editUserSuccess"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              @click.prevent="onModalOk"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <h5>Meus dados atualizados com sucesso!</h5>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-secondary"
              @click.prevent="onModalOk">OK</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import loopback from '@/services/loopback'
import { triggerUserDataUpdateWebhook } from '@/services/user-data-update-webhook'
import { formatPhoneMask, phoneDigitsOnly, phoneToNationalDisplay, allowOnlyNumericKeydown } from '@/utils/phone'

export default {
  name: 'UserProfile',
  data () {
    return {
      name: null,
      email: null,
      phone: '',
      initialName: null,
      initialPhone: '',
      error: null
    }
  },
  computed: {
    phoneDisplay: {
      get () {
        return formatPhoneMask(this.phone || '')
      },
      set (value) {
        this.phone = phoneDigitsOnly(value)
      }
    }
  },
  mounted () {
    this.$nextTick(function () {
      this.getUser()
    })
  },
  methods: {
    allowOnlyNumericKeydown,
    onSubmit () {
      const form = this.$refs.editUserForm
      this.error = null
      if (form.checkValidity()) {
        const paramsToUpdate = {
          email: this.email,
          name: this.name,
          phone: this.phone || null
        }
        const hasChanges = this.name !== this.initialName || this.phone !== this.initialPhone
        loopback
          .patch('/users', paramsToUpdate)
          .then(user => {
            this.$store.commit('auth/setUser', user)
            if (hasChanges) {
              triggerUserDataUpdateWebhook({
                email: user.email,
                name: user.name,
                phone: user.phone,
                domain: this.$store.state.auth.organization.domain
              })
            }
            this.setUser(user)
            $(this.$refs.editUserSuccess).modal('show')
          })
          .catch(err => {
            this.error = err
            // TEL-2243: o `friendly` do interceptor ja resolve `details.messages` pelo
            // FIELD_MESSAGES, mantem em pt-BR o que o backend ja manda traduzido e nomeia
            // o campo quando nao ha texto proprio. Montar `lines` aqui devolvia o texto do
            // LoopBack em ingles e ainda sobrescrevia a traducao.
          })
      } else {
        this.error = {
          message: 'O campo nome é obrigatório'
        }
      }
    },
    getUser () {
      const user = this.$store.state.auth.user
      if (user) {
        this.setUser(user)
      }
    },
    setUser (user) {
      this.name = user.name
      this.email = user.email
      this.phone = user.phone ? phoneToNationalDisplay(String(user.phone)) : ''
      this.initialName = this.name
      this.initialPhone = this.phone
    },
    onModalOk () {
      this.$router.go(0)
    }
  },
  watch: {}
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/User/Profile.vue